import { OnInit, Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-checkout-outcome-modal',
  templateUrl: './checkout-outcome-modal.component.html',
  styleUrls: [],
  standalone: false
})
export class CheckoutOutcomeModal implements OnInit {
  success = false;
  method = '-';
  amount = 0;
  balance?: number;
  readonly displaySuccessData = {
    bgColor: "tw-bg-[#E4F6EA] tw-text-secondary",
    iconClass: "fa fa-check",
    modalTitle: "mysec.depositOutcome.success.title",
    modalSubTitle: "mysec.depositOutcome.success.subTitle",
    buttonText: "mysec.depositOutcome.success.button"
  }
  readonly displayPendingData = {
    bgColor: "tw-bg-warning-light tw-text-warning",
    iconClass: "fa fa-clock-o",
    modalTitle: "mysec.depositOutcome.pending.title",
    modalSubTitle: "mysec.depositOutcome.pending.subTitle",
    buttonText: "mysec.depositOutcome.pending.button"
  }
  displayTranslateData: {
    bgColor: string;
    iconClass: string;
    modalTitle: string;
    modalSubTitle: string;
    buttonText: string;
  };
  ngOnInit(): void {
    this.displayTranslateData = this.displayPendingData;
  }
  constructor(public activeModal: NgbActiveModal) {}
  close() {
    this.activeModal.dismiss();
  }
  setSuccess(status: boolean){
    this.success = status;
    this.displayTranslateData = status? this.displaySuccessData : this.displayPendingData;
  }
}
